import React, { useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProductCard from './ProductCard';
import { products } from '../data';

export default function Products({ copy }) {
  const navigate = useNavigate();
  // Duplicated so the CSS marquee loops seamlessly
  const looped = useMemo(() => [...products, ...products], []);

  return (
    <section className="kido-products-section" id="shop">
      <div className="kido-section-heading">
        <div>
          <p className="kido-eyebrow">01  /  {copy.shop}</p>
          <h2>{copy.collection}</h2>
          <p>{copy.collectionSub}</p>
        </div>
        <Link className="kido-text-link" to="/shop">{copy.seeAll} <span>↗</span></Link>
      </div>
      <div className="kido-carousel-window">
        <div className="kido-product-track">
          {looped.map((product, i) => (
            <ProductCard
              key={`${product.name}-${i}`}
              product={product}
              addLabel={copy.add}
              onAdd={() => navigate('/shop')}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
